module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_IX",
      "role": "doc-pagebreak",
      "title": "IX"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("A")]), _vm._v("bout ten years ago, I wrote a book. It was a great experience, but I didn’t foresee my life ever moving in that direction again. However, when the opportunity arose to contribute to this series, I couldn’t resist; I’ve always seen my primary mission as making history accessible to the person on the street. But I never would have gotten here without significant assistance.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("First of all, I want to thank my colleagues at "), _c('i', [_vm._v("Christian History")]), _vm._v(" magazine for the collegial working atmosphere that has gotten me through the editing of thirty-four issues (as of this writing). Overseeing a magazine that covers all eras, movements, and people in church history has given me a broad and deep background from which to tell this story. Plus, these fine people gave me time off to help me finish! Thank you so much to Bill Curtis, Chris Armstrong, Dawn Moore, Kaylena Radcliff, Dan Graves, Meg Moss, Doug Johnson, and Max Pointner.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I also want to thank Grant Wacker for, long ago, believing in me as a doctoral student. Without him there would have been no first book, and hence no second one. I owe you a thousand sarsaparillas, Grant.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Then, I am grateful to David McNutt, my editor at InterVarsity Press, for suggesting the idea, believing it could be done, and waiting patiently and graciously for me to do it.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_X",
      "role": "doc-pagebreak",
      "title": "X"
    }
  }), _vm._v("It has been my great pleasure to serve two churches as a part-time priest during the writing of this book and to participate in the worship life of several others. The debates and the affirmations of church history ultimately work themselves out in the worship and service of local congregations. At Saint Mark’s Episcopal Church (Hazard, KY), Saint John’s Episcopal Church (Corbin, KY), the Episcopal Church of Our Saviour (Richmond, KY), and First United Methodist Church (Richmond, KY), there are people who love the Lord, believe the gospel, and serve the world, and I would not have made it this far without them.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I wrote quite a lot of this book at a holiday cottage near Madley in Herefordshire, England. Simon Lockett and the Wye Dore Parishes welcomed my family into the life of the parish for a week—and I got to see a two-thousand-year-old yew tree. If you visit, go to the Hub and get some homebakes, and come back on Sunday for Eucharist. Having coffee in the nave of a church founded in the sixth century will change you.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Finally, what I owe my family is incalculable. I always know I can depend on my brother and sister-in-law Jonathan and Melissa Woodruff and nephew Will for general love and support—and on my in-laws, R. Barry and Trudy Harvey Tait, for probing questions, faithful Christian witness, proofreading, and lunch. The sharp intellects and passion for a just world of my daughters, Catherine Elanor and Elizabeth Beatrice, teach me the meaning of Proverbs 27:17 every single day.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My husband, Edwin, knows the answer to everything I’ve ever asked him (and answers more quickly than Google); is a full partner in parenting and homemaking; loaned me a few unpublished conceptual paragraphs on purgatory for "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/Text/chap5#chap-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter five")]), _vm._v("; and loves all things that are good and true and beautiful. Indeed, a star shone on the hour of our meeting.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XI",
      "role": "doc-pagebreak",
      "title": "XI"
    }
  }), _vm._v("Just before my first book came out, my mother, Marilyn Delle Stanger Woodruff, died. Just before this one came out, my father, John Hurlbut Woodruff, died. Above all I thank them, and offer in their memory the famed prayer from the Cambridge Lessons and Carols service: “Lastly, let us remember before God all those who rejoice with us, but upon another shore, and in a greater light, that multitude which no man can number, whose hope was in the Word made flesh, and with whom in the Lord Jesus we are forever one.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Mom got the first book. Dad gets this one.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3580722","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/pre2.vue
// module id = 69
// module chunks = 0